module.exports = __webpack_public_path__ + "img/dash-card-waiting.1164aa6d.svg";